// extracted by mini-css-extract-plugin
export var arrowDown = "DropdownSelect-module--arrowDown--a8a6c";
export var dropdownCopy = "DropdownSelect-module--dropdownCopy--f7c16";
export var group = "DropdownSelect-module--group--88c18";
export var list = "DropdownSelect-module--list--b60db";
export var menuItem = "DropdownSelect-module--menuItem--28699";
export var multiSelect = "DropdownSelect-module--multiSelect--89c28";
export var root = "DropdownSelect-module--root--1b1dc";
export var singleSelect = "DropdownSelect-module--singleSelect--097aa";
export var title = "DropdownSelect-module--title--b0a03";